// Import react and router DOM
import React, { useContext, useEffect, useState } from "react";

//Import components

//Import states, contexts and CSS
import productionSheetContext from "../../../store/productionSheetContext.jsx";
import { Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import { Table } from "react-bootstrap";
import { PlusCircle, XCircle,  } from "react-bootstrap-icons";

import { Container, Row, Col } from "react-bootstrap";

import { useActiveUser } from "../../../store/activeUserContext.jsx";


// Gestione delle lingue
import { useTranslation } from "react-i18next";

const CuttingDieModalRow = ({ index, cuttingDie,update,setUpdate, onHide }) => {
  const { t } = useTranslation();
  const { activeUser, setActiveUser } = useActiveUser();
  const token = localStorage.getItem("token");

  const { setBagDetailsInput } = useContext(
    productionSheetContext
  );


  const handleDeleteCuttingDie = async () => {
    console.log("cutting die to delete", `${process.env.REACT_APP_SERVER_URL}/api/cuttingDie/users/${activeUser._id}/${cuttingDie._id}`);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/cuttingDie/users/${activeUser._id}/${cuttingDie._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const data = await response.json();
      if (response.ok) { 
        alert(data.message);
      }
      setUpdate(!update);


    } catch {
      console.error("Error deleting cutting die");
    }
  }

  const importCuttingDie = () => {
    setBagDetailsInput((prev) => ({...prev, cuttingDieWidth: cuttingDie.width, cuttingDieHeight: cuttingDie.height }));
onHide();

  }



  return (
    <>
      <tr >
        <td>{index + 1}</td>
        <td>{cuttingDie.width}</td>
        <td>{cuttingDie.height}</td>
        <td>
          <Button
            variant="danger"
            onClick={handleDeleteCuttingDie}

          >
            <XCircle size={16} />
          </Button>
          <Button variant="success" 
          onClick={importCuttingDie}
          >
            Import
          </Button>
        </td>
      </tr>
    </>
  );
};

const CuttingDieModal = (props) => {
  const { t } = useTranslation();
  const { activeUser, setActiveUser } = useActiveUser();
  const token = localStorage.getItem("token");

  const [cuttingDieList, setCuttingDieList] = useState([]);

  const [newCuttingDie, setNewCuttingDie] = useState({ width: 0, height: 0 });
  const handleNewCuttingDieChange = (e) => {
    const { value, name } = e.target;
    setNewCuttingDie({ ...newCuttingDie, [name]: parseFloat(value) });
  };

  const [update, setUpdate] = useState(false);

  useEffect(() => {
    const fetchCuttingDie = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/api/cuttingDie/users/${activeUser._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          setCuttingDieList(data);
        }
      } catch (error) {
        console.error("Error fetching cutting dies:", error);
      }
    };

    fetchCuttingDie();

    console.log(cuttingDieList);
  }, [ update]);

  const sendNewCuttingDie = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/cuttingDie/users/${activeUser._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(newCuttingDie),
        }
      );
      const data = await response.json();
      if (response.ok) {
        alert("Cutting die added successfully");
      }
      setNewCuttingDie({ width: 0, height: 0 });

      // se update è true allora diventa false, e viceversa
      setUpdate(!update);
    } catch (error) {
      console.error("Error sending cutting die:", error);
      alert("Error sending cutting die");
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            cutting die list
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Width</th>
                <th>Height</th>
                <th> Action</th>
              </tr>
            </thead>
            <tbody>
              {cuttingDieList.map((die, index) => (
                <CuttingDieModalRow cuttingDie={die} index={index} setUpdate={setUpdate} update={update} onHide = {props.onHide}/>
              ))}
            </tbody>
          </Table>
          <hr />
          <Container>
            <Row>
              <Col xs={12} md={5}>
                <InputGroup
                  controlId="newCuttingDieWidth"
                  className={"mb-2 d-flex align-items-center"}
                >
                  <Form.Label className={"w-50"}>New Width </Form.Label>
                  <Form.Control
                    className="text-end"
                    type="number"
                    placeholder=""
                    name="width"
                    min={0}
                    max={99}
                    onChange={handleNewCuttingDieChange}
                    value={newCuttingDie?.width || 0}
                  ></Form.Control>
                  <InputGroup.Text> Cm </InputGroup.Text>
                </InputGroup>
              </Col>
              <Col xs={12} md={5}>
                <InputGroup
                  controlId="newCuttingDieHeight"
                  className={"mb-2 d-flex align-items-center"}
                >
                  <Form.Label className={"w-50"}>New Height </Form.Label>
                  <Form.Control
                    className="text-end"
                    type="number"
                    placeholder=""
                    name="height"
                    min={0}
                    max={99}
                    onChange={handleNewCuttingDieChange}
                    value={newCuttingDie?.height || 0}
                  ></Form.Control>
                  <InputGroup.Text> Cm </InputGroup.Text>
                </InputGroup>
              </Col>

              <Col xs={12} md={2}>
                <Button onClick={sendNewCuttingDie}>
                  <PlusCircle />{" "}
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>{" "}
    </>
  );
};

export default CuttingDieModal;
